export default {"src":"/_next/static/media/DKK.137eb190.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};